<template>
		<!-- Main content -->
		<div class="content-wrapper">

			<!-- Page header -->
			<app-breadcrumb/>
			<!-- /page header -->

			<!-- Content area -->
			<div class="content">

			<!-- Simple panel -->
			<div class="panel panel-flat border-top-lg border-top-success">

				<div class="panel-body">
					<p><img src="../../assets/images/logo.png" class="img-responsive" alt="APICodes" title="APICodes"></p>
					<p>Thank you for purchasing <a href="https://apicodes.com/product/apicodes-embed-manager-v2/" target="_blank" title="APICodes Embed Manager v2">APICodes Embed Manager v2</a> from us!</p>
					<p>If you have any questions. Please don't hesitate to contact us on Skype: <a href="mailto:support@apicodes.com">support@apicodes.com</a>. We will help you as we can!</p>
				</div>

			</div>
			<!-- /simple panel -->

				<!-- Footer -->
				<app-footer/>
				<!-- /footer -->

			</div>
			<!-- /content area -->
		</div>
		<!-- /main content -->
</template>

<script>
export default {

  name: 'About',

  data () {
    return {

    }
  }
}
</script>

<style lang="css" scoped>
</style>


// WEBPACK FOOTER //
// src/components/admin/About.vue